import React from 'react';
import styles from './Escalator.module.css';
import BasePanel from '../BasePanel/BasePanel.jsx';

const escalatorImg = require('../../../../images/Illustration_Classic_Escalator.png');
const escalatorCanNotLoadImg = require('../../../../images/adshel_can_not_load_adcopy.png');

const Escalator = ({ mediaArray, videoAutoPlayInterval }) => {

    return (
        <BasePanel
            mediaArray={mediaArray}
            backgroundImage={escalatorImg}
            cannotLoadImage={escalatorCanNotLoadImg}
            customStyles={styles}
            videoAutoPlayInterval={videoAutoPlayInterval}
        />
    );
};

export default Escalator;